import { render, staticRenderFns } from "./ServiceDirectoriesView.vue?vue&type=template&id=235c66a5&scoped=true&"
import script from "./ServiceDirectoriesView.vue?vue&type=script&lang=ts&"
export * from "./ServiceDirectoriesView.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceDirectoriesView.vue?vue&type=style&index=0&id=235c66a5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235c66a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
